import { action } from 'utils/actions'

export const DRAFT_DEALS_CANCEL = 'DRAFT_DEALS_CANCEL'
export const DRAFT_DEALS_EDIT = 'DRAFT_DEALS_EDIT'
export const DRAFT_DEALS_SAVE = 'DRAFT_DEALS_SAVE'
export const DRAFT_DEALS_UPDATE_FIELD = 'DRAFT_DEALS_UPDATE_FIELD'

export const draftDealsCancel = () => action(DRAFT_DEALS_CANCEL)
export const draftDealsEdit = (deals) => action(DRAFT_DEALS_EDIT, { deals })
export const draftDealsSave = () => action(DRAFT_DEALS_SAVE)
export const draftDealsUpdateField = (dealId, data) => action(DRAFT_DEALS_UPDATE_FIELD, { dealId, data })



/** WEBPACK FOOTER **
 ** ./src/actions/draft-deals/draft-deals.js
 **/